export const CHARGE_POINT_REFRESH_TIMEOUT = 10000
